"use client";

import { HStack, Text } from "@chakra-ui/react";
import type { Criterion } from "@/generated/fastapi";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import WithControlButtons from "@/shared/ui/actions/WithControlButtons";
import WithSwipeSelector from "@/shared/ui/gestures/WithSwipeSelector";
import { iconSizePresets } from "@/shared/config/iconSizePresets";

interface SearchFullContentChipProps {
  chip: Criterion;
  contentText: string;
  isMobileDevice: boolean;
  isSelected: boolean;
  onToggle: () => void;
}

export default function SearchFullContentChip({
  chip,
  contentText,
  isMobileDevice,
  isSelected,
  onToggle,
}: SearchFullContentChipProps) {
  return (
    <WithSwipeSelector
      key={chip.id}
      isMobile={isMobileDevice}
      selection={{
        isSelected,
        onToggle,
        humanReadable: "Toggle full focus content search",
      }}
    >
      <WithControlButtons
        clipboard={{
          value: chip.mindstring,
          humanReadable: "Copy full focus content",
        }}
      >
        <HStack>
          <GenericIcon
            icon="profile_focus"
            size={iconSizePresets.chipAction}
            humanReadable="Full focus content"
          />
          <Text fontSize="sm" fontWeight="medium" lineClamp={2} flex="1">
            {contentText}
          </Text>
        </HStack>
      </WithControlButtons>
    </WithSwipeSelector>
  );
}
